module.exports = __webpack_public_path__ + "img/permaweb_news_normal.608dd1a6.svg";